<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      viewBox="0 0 24 24"
    >
      <path
        d="M18.9619 13.0082C18.7708 13.2152 18.6738 13.4936 18.6738 13.7924C18.6738 17.5232 15.6537 20.5433 11.9229 20.5433C8.19205 20.5433 5.17188 17.5232 5.17188 13.7924C5.17188 10.0616 8.19205 7.04138 11.9229 7.04138C12.4288 7.04138 12.8947 7.06724 13.3125 7.12244L10.8135 9.60486C10.5726 9.82534 10.5 10.1198 10.5 10.3744C10.5 10.9843 10.9612 11.4554 11.5615 11.4554C11.8913 11.4554 12.1384 11.3324 12.333 11.1508L12.3408 11.1429L16.3633 7.099C16.5961 6.87596 16.7051 6.60415 16.7051 6.30212C16.7051 6.0065 16.5841 5.71169 16.3564 5.49744L12.3516 1.42419C12.1434 1.20481 11.8775 1.09998 11.5615 1.09998C10.9516 1.09998 10.5 1.6006 10.5 2.20056C10.5 2.47467 10.5926 2.74539 10.7959 2.96228L12.7539 4.92029C12.4844 4.89464 12.2049 4.87927 11.9229 4.87927C6.99154 4.87927 3 8.87081 3 13.8021C3 18.7334 6.99154 22.725 11.9229 22.725C16.8542 22.725 20.8457 18.7334 20.8457 13.8021C20.8457 13.4921 20.7373 13.209 20.5342 13.0023C20.3305 12.7951 20.0484 12.682 19.7354 12.682C19.4274 12.682 19.1552 12.7989 18.9619 13.0082Z"
      />
    </svg>
  </template>
  
  <script>
  export default {
    name: 'IconApecRefresh',
  };
  </script>
  
  <style scoped>
  .icon {
    display: inline-block;
    width: 1.5em;
    height: 1.5em;
    fill: inherit;
    flex-shrink: 0;
  }
  </style>
  